import { render, staticRenderFns } from "./passPointComponents.vue?vue&type=template&id=6d05162e&"
import script from "./passPointComponents.vue?vue&type=script&lang=js&"
export * from "./passPointComponents.vue?vue&type=script&lang=js&"
import style0 from "./passPointComponents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d05162e')) {
      api.createRecord('6d05162e', component.options)
    } else {
      api.reload('6d05162e', component.options)
    }
    module.hot.accept("./passPointComponents.vue?vue&type=template&id=6d05162e&", function () {
      api.rerender('6d05162e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/travel/components/passPointComponents.vue"
export default component.exports